import { render } from "./CallTypePerUserBarChart.vue?vue&type=template&id=1e1b6a11&ts=true"
import script from "./CallTypePerUserBarChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallTypePerUserBarChart.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/charts/CallTypePerUserBarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e1b6a11"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e1b6a11', __exports__)) {
    api.reload('1e1b6a11', __exports__)
  }
  
  module.hot.accept("./CallTypePerUserBarChart.vue?vue&type=template&id=1e1b6a11&ts=true", () => {
    api.rerender('1e1b6a11', render)
  })

}


export default __exports__